// Helpers + badge for surfacing the two training-demo projects (Hans Maier and
// Sabine Schulte) so trainers can never confuse them with real customer data.

export const DEMO_PROJECT_IDS = new Set([
  "17b3b9f0-21c4-4d59-8af9-6b1db403616a", // Hans Maier
  "d3m051ne-1ead-4d34-9a51-5abineschulte", // Sabine Schulte
]);

export const isDemoProject = (project) => {
  if (!project) return false;
  return DEMO_PROJECT_IDS.has(project.id || project.project_id);
};

/** Small inline pill that calls out a training-demo dataset. */
export const TrainingBadge = ({ size = "sm", className = "" }) => {
  const dims =
    size === "lg"
      ? "h-6 px-2.5 text-[10.5px] gap-1"
      : "h-5 px-2 text-[9.5px] gap-1";
  return (
    <span
      data-testid="training-demo-badge"
      title="Schulungs-/Demo-Projekt – keine echten Kundendaten."
      className={`inline-flex items-center font-bold uppercase tracking-[0.12em] rounded-md bg-violet-500/15 text-violet-300 border border-violet-500/40 ${dims} ${className}`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-violet-400" />
      Schulung
    </span>
  );
};
